import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { SupervBaseRoutes } from './supervbase.routes';
import { ListSupervBaseComponent } from './list-supervbase/list-supervbase.component';
import { FormSupervBaseComponent } from './_components/form-supervbase/form-supervbase.component';
import { AddSupervBaseComponent } from './add-supervbase/add-supervbase.component';
import { EditSupervBaseComponent } from './edit-supervbase/edit-supervbase.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [SupervBaseRoutes, SharedDocumalisModule, TranslateModule, FormSupervBaseComponent],
    declarations: [ListSupervBaseComponent, AddSupervBaseComponent, EditSupervBaseComponent],
})
export class SupervBaseModule {}
